var jade = require("/Users/nmd/dev/vsct.info/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<h3>Информация по вывозу контейнера № {{ title }}</h3><table class=\"custom_table\"><thead><tr><th>Дата</th><th>Транспорт</th><th>Водитель</th><th>Примечание</th><th>Статус заявки</th></tr></thead><tbody><tr><td>{{ date}}</td><td>{{ transport}}</td><td>{{ voditel}}</td><td>{{ message}}</td><td>{{ status}}</td></tr></tbody></table><component is=\"alert\" name=\"auto-export-cnt\" data-message=\"{{ data.message }}\"></component>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/auto-export-cnt/component.jade
 ** module id = 95
 ** module chunks = 0
 **/